(function(){
  function init(){
  var root=document.getElementById('bp-root');
  if(!root) return;
  var mainimg=document.getElementById('bp-mainimg');
  var priceEl=document.getElementById('bp-price');
  var cta=document.getElementById('bp-cta');
  var ctaPrice=document.getElementById('bp-cta-price');
  var ctaText=document.getElementById('bp-cta-text');
  var errEl=document.getElementById('bp-err');
  var nTitle=document.getElementById('bp-notify-title');
  var nSub=document.getElementById('bp-notify-sub');
  var swatches=root.querySelectorAll('#bp-swatches .bp-sw');
  var bundles=root.querySelectorAll('#bp-bundles .bp-bundle');
  var thumbs=root.querySelectorAll('.bp-thumb');
  var state={variant:null,available:false,name:''};

  function money(cents){
    return (cents/100).toLocaleString('da-DK',{minimumFractionDigits:2,maximumFractionDigits:2})+' kr.';
  }
  function basePrice(){
    var el=root.querySelector('#bp-bundles .bp-bundle[data-kind="single"] .bp-b-price');
    return el?(parseInt(el.getAttribute('data-base'),10)||0):0;
  }
  function isVisible(el){ return el && el.style.display!=='none'; }

  // Viser kun de print, der findes i det valgte materiale
  function applyMaterial(bd){
    var btn=bd.querySelector('.bp-mat-btn.is-on');
    var group=bd.querySelector('.bp-mini--bedding');
    if(!btn||!group) return;
    var val=btn.getAttribute('data-mat');
    var first=null;
    group.querySelectorAll('.bp-mini-sw').forEach(function(m){
      var ok=(m.getAttribute('data-mat')===val);
      m.style.display=ok?'':'none';
      if(ok&&!first) first=m;
    });
    var on=group.querySelector('.bp-mini-sw.is-on');
    if(!isVisible(on)){
      group.querySelectorAll('.bp-mini-sw').forEach(function(x){x.classList.remove('is-on');});
      if(first) first.classList.add('is-on');
    }
  }

  function syncSub(bd){
    if(!bd) return;
    applyMaterial(bd);
    bd.querySelectorAll('.bp-mini').forEach(function(g){
      var on=g.querySelector('.bp-mini-sw.is-on');
      if(!isVisible(on)){
        g.querySelectorAll('.bp-mini-sw').forEach(function(x){x.classList.remove('is-on');});
        var f=null;
        g.querySelectorAll('.bp-mini-sw').forEach(function(m){ if(!f&&isVisible(m)) f=m; });
        if(f) f.classList.add('is-on');
      }
    });
  }
  function sumOf(bd){
    var s=0;
    bd.querySelectorAll('.bp-mini').forEach(function(g){
      var on=g.querySelector('.bp-mini-sw.is-on');
      if(isVisible(on)) s+=parseInt(on.dataset.price,10)||0;
    });
    return s;
  }
  function discountOf(bd){
    var d=parseFloat(bd.getAttribute('data-discount')||'0');
    return isNaN(d)?0:d;
  }
  function totalOf(bd,base){
    var full=base+sumOf(bd);
    var d=discountOf(bd);
    return {full:full,net:Math.round(full*(1-d)),d:d};
  }
  function render(){
    var base=basePrice();
    bundles.forEach(function(bd){
      var pEl=bd.querySelector('.bp-b-price');
      if(!pEl) return;
      var t=totalOf(bd,base);
      if(t.d>0){pEl.innerHTML=money(t.net)+'<s>'+money(t.full)+'</s>';}
      else{pEl.textContent=money(t.full);}
    });
    var active=root.querySelector('#bp-bundles .bp-bundle.is-on');
    var total=base;
    if(active) total=totalOf(active,base).net;
    if(!state.available){
      cta.setAttribute('disabled','disabled');
      ctaText.textContent='Udsolgt lige nu';
      ctaPrice.textContent='';
      if(nTitle) nTitle.textContent='Udsolgt lige nu';
      if(nSub) nSub.textContent='Skriv dig op, så giver vi besked, når '+(state.name||'dette print')+' er tilbage på lager.';
    }else{
      cta.removeAttribute('disabled');
      ctaText.textContent='Læg i kurv';
      ctaPrice.textContent='· '+money(total);
      if(nTitle) nTitle.textContent='Få besked om nye farver';
      if(nSub) nSub.textContent='Skriv dig op, så er du den første, der hører det, når vi får nye print og farver hjem.';
    }
  }

  function filterGallery(name){
    var shown=[];
    var key=(name||'').toLowerCase().trim();
    thumbs.forEach(function(t){
      var alt=(t.getAttribute('data-alt')||'').toLowerCase();
      var hit=key&&alt.indexOf(key)>-1;
      t.style.display=hit?'':'none';
      if(hit) shown.push(t);
    });
    if(!shown.length){ thumbs.forEach(function(t){t.style.display='';shown.push(t);}); }
    thumbs.forEach(function(t){t.classList.remove('is-on');});
    if(shown[0]){ shown[0].classList.add('is-on'); mainimg.src=shown[0].getAttribute('data-src'); }
  }

  thumbs.forEach(function(b){
    b.addEventListener('click',function(ev){
      ev.preventDefault();
      thumbs.forEach(function(x){x.classList.remove('is-on');});
      b.classList.add('is-on');
      mainimg.src=b.getAttribute('data-src');
    });
  });

  function selectSwatch(sw){
    swatches.forEach(function(x){x.classList.remove('is-on');});
    sw.classList.add('is-on');
    state.variant=sw.dataset.variant;
    state.available=(sw.dataset.available==='true');
    state.name=sw.getAttribute('data-name')||'';
    if(priceEl) priceEl.textContent=sw.dataset.price;
    var hid=document.getElementById('bp-notify-variant');
    if(hid) hid.value=state.name;
    filterGallery(state.name);
    render();
  }
  swatches.forEach(function(sw){
    sw.addEventListener('click',function(ev){ev.preventDefault();selectSwatch(sw);});
  });

  function activate(bd){
    bundles.forEach(function(x){x.classList.remove('is-on');});
    bd.classList.add('is-on');
    syncSub(bd);
    render();
  }
  bundles.forEach(function(bd){
    bd.addEventListener('click',function(e){
      if(e.target.closest('.bp-mini-sw')||e.target.closest('.bp-mat-btn')) return;
      activate(bd);
    });
    bd.querySelectorAll('.bp-mat-btn').forEach(function(mb){
      mb.addEventListener('click',function(ev){
        ev.stopPropagation();ev.preventDefault();
        if(!bd.classList.contains('is-on')) activate(bd);
        bd.querySelectorAll('.bp-mat-btn').forEach(function(x){x.classList.remove('is-on');});
        mb.classList.add('is-on');
        applyMaterial(bd);
        render();
      });
    });
    bd.querySelectorAll('.bp-mini').forEach(function(group){
      group.querySelectorAll('.bp-mini-sw').forEach(function(m){
        m.addEventListener('click',function(ev){
          ev.stopPropagation();ev.preventDefault();
          if(!bd.classList.contains('is-on')) activate(bd);
          group.querySelectorAll('.bp-mini-sw').forEach(function(x){x.classList.remove('is-on');});
          m.classList.add('is-on');
          render();
        });
      });
    });
  });

  var flipA=document.getElementById('bp-flip-a');
  var flipB=document.getElementById('bp-flip-b');
  var btnA=document.getElementById('bp-flip-btn-a');
  var btnB=document.getElementById('bp-flip-btn-b');
  if(flipA&&flipB&&btnA&&btnB){
    btnA.addEventListener('click',function(){flipA.classList.remove('bp-hide');flipB.classList.add('bp-hide');btnA.classList.add('is-on');btnB.classList.remove('is-on');});
    btnB.addEventListener('click',function(){flipB.classList.remove('bp-hide');flipA.classList.add('bp-hide');btnB.classList.add('is-on');btnA.classList.remove('is-on');});
  }

  cta.addEventListener('click',function(ev){
    ev.preventDefault();
    if(cta.hasAttribute('disabled')) return;
    errEl.hidden=true;
    var items=[{id:parseInt(state.variant,10),quantity:1}];
    var active=root.querySelector('#bp-bundles .bp-bundle.is-on');
    if(active&&active.dataset.kind!=='single'){
      active.querySelectorAll('.bp-mini').forEach(function(g){
        var on=g.querySelector('.bp-mini-sw.is-on');
        if(isVisible(on)) items.push({id:parseInt(on.dataset.variant,10),quantity:1});
      });
    }
    cta.setAttribute('disabled','disabled');
    ctaText.textContent='Lægger i kurv…';
    ctaPrice.textContent='';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:items})
    }).then(function(r){
      if(!r.ok){return r.json().then(function(j){throw new Error(j.description||j.message||'Kunne ikke lægge i kurv');});}
      return r.json();
    }).then(function(){window.location.href='/cart';})
    .catch(function(e){
      cta.removeAttribute('disabled');
      errEl.textContent=e.message;
      errEl.hidden=false;
      render();
    });
  });

  bundles.forEach(function(b){b.classList.remove('is-on');syncSub(b);});
  var single=root.querySelector('#bp-bundles .bp-bundle[data-kind="single"]');
  if(single) single.classList.add('is-on');
  var firstAvail=null;
  swatches.forEach(function(sw){if(!firstAvail&&sw.dataset.available==='true') firstAvail=sw;});
  if(firstAvail){selectSwatch(firstAvail);}else if(swatches[0]){selectSwatch(swatches[0]);}
  render();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();